/* Автоматически генерируемый файл */
import { type ThemeSizeTokens } from '@direct-frontend/components';

/**
 * Размерные токены для подкомпонентов элемента, определяют размеры иконок, хелпов, лейблов
 *
 * Генерируется автоматически по значениям из yml файла, лучше не редактировать руками
 */
export const themeSizeTokens: ThemeSizeTokens = {
    '4xs': {
        iconSize: '8',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 2,
        paddingHIcon: 5,
        paddingHText: 5,
        paddingH: 5,
        paddingHIconSquare: 4,
        paddingVCard: 2,
        paddingHCard: 5,
    },
    '3xs': {
        iconSize: '12',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 2,
        paddingHIcon: 6,
        paddingHText: 6,
        paddingH: 6,
        paddingHIconSquare: 4,
        paddingVCard: 2,
        paddingHCard: 6,
    },
    '2xs': {
        iconSize: '12',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 4,
        paddingHIcon: 8,
        paddingHText: 8,
        paddingH: 8,
        paddingHIconSquare: 6,
        paddingVCard: 4,
        paddingHCard: 8,
    },
    xs: {
        iconSize: '16',
        helpSize: '16',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 6,
        paddingHIcon: 8,
        paddingHText: 12,
        paddingH: 10,
        paddingHIconSquare: 8,
        paddingVCard: 6,
        paddingHCard: 12,
    },
    s: {
        iconSize: '16',
        helpSize: '16',
        innerLabelSize: '3xs',
        outerLabelSize: '3xs',
        paddingV: 8,
        paddingHIcon: 10,
        paddingHText: 16,
        paddingH: 12,
        paddingHIconSquare: 10,
        paddingVCard: 8,
        paddingHCard: 16,
    },
    m: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '3xs',
        paddingV: 10,
        paddingHIcon: 14,
        paddingHText: 20,
        paddingH: 14,
        paddingHIconSquare: 10,
        paddingVCard: 14,
        paddingHCard: 20,
    },
    l: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 14,
        paddingHIcon: 14,
        paddingHText: 20,
        paddingH: 20,
        paddingHIconSquare: 16,
        paddingVCard: 14,
        paddingHCard: 20,
    },
    xl: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 16,
        paddingHIcon: 24,
        paddingHText: 24,
        paddingH: 24,
        paddingHIconSquare: 20,
        paddingVCard: 16,
        paddingHCard: 24,
    },
    '2xl': {
        iconSize: '24',
        helpSize: '24',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 20,
        paddingHIcon: 32,
        paddingHText: 32,
        paddingH: 32,
        paddingHIconSquare: 28,
        paddingVCard: 20,
        paddingHCard: 32,
    },
    layout: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 28,
        paddingHIcon: 24,
        paddingHText: 24,
        paddingH: 36,
        paddingHIconSquare: 36,
        paddingVCard: 28,
        paddingHCard: 36,
    },
};
